import range from "./range";
import pad from "./pad";

const dayHash = {
  0: "Sun",
  1: "Mon",
  2: "Tue",
  3: "Wed",
  4: "Thu",
  5: "Fri",
  6: "Sat"
};

const longDayHash = {
  0: "Sunday",
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday"
};

const numHash = Object.keys(dayHash).reduce((acc, key) => {
  acc[dayHash[key]] = key;
  return acc;
}, {});

const longNumHash = Object.keys(longDayHash).reduce((acc, key) => {
  acc[longDayHash[key]] = key;
  return acc;
}, {});

export function dayToNum(day) {
  return numHash[day] || "";
}

export function longDayToNum(day) {
  return longNumHash[day] || "";
}

export function numToDay(num) {
  return dayHash[num + ""] || "";
}

export function numToLongDay(num) {
  return longDayHash[num + ""] || "";
}

export const zones = range(-11, -8, 0.25)
  .concat(range(-8, -4, 1))
  .concat(range(-4, 14 + 1, 0.25));

export function utcOffset() {
  return new Date().getTimezoneOffset() / -60;
}

export function utcTimestamp() {
  const d = new Date();
  return d.getTime() + d.getTimezoneOffset() * 60000;
}

export function militaryTime(time) {
  return time && (time.meridiem === "PM" ? time.hour + 12 : time.hour);
}

export function amOrPm(date) {
  return date.getHours() < 12 ? "AM" : "PM";
}

export function getHours(date) {
  const h = date.getHours() || 12;
  return h > 12 ? h - 12 : h;
}

export function getMinutes(date) {
  return pad(date.getMinutes());
}

export function localTime(timestamp, zone) {
  return new Date(timestamp + zone * 3600000);
}



// WEBPACK FOOTER //
// ./src/utils/time.js